import axios from "axios";

// Base API en chemin relatif same-origin : l'ingress route /api vers le backend
// (preview, production, domaine personnalisé, Édition Locale). Évite les pannes
// liées à l'URL absolue figée au build (ex : redirection www ↔ apex qui casse le preflight CORS).
export const API_BASE = "/api";

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });
// Authentification par cookie httpOnly uniquement (jamais de token en localStorage — protection XSS)

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erreur réseau";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export function openPdf(path) {
  window.open(`${API_BASE}${path}`, "_blank");
}

export function fileUrl(path) {
  return `${API_BASE}/files/${path}`;
}

export function exportFile(path) {
  window.open(`${API_BASE}${path}`, "_blank");
}
